import { fmtDuration } from "@/utils/format";
import { Slider } from "@/components/ui/Slider";
import { usePlayer } from "@/hooks/usePlayer";
import { usePlayerProgress } from "@/hooks/usePlayerProgress";

export function ProgressBar() {
  const { duration, current, seek } = usePlayer();
  const progress = usePlayerProgress();

  // Defensive: `<audio>.duration` is NaN before metadata loads, and the DB
  // sometimes has duration_ms=0 for Spotify search results that shipped
  // without one. Fall back to a known-good number in that order, else 0.
  const durFromAudio = Number.isFinite(duration) && duration > 0 ? duration : 0;
  const durFromTrack = current?.duration_ms ? current.duration_ms / 1000 : 0;
  const total = durFromAudio || durFromTrack;
  const prog = Number.isFinite(progress) && progress >= 0 ? progress : 0;
  const known = total > 0;

  return (
    <div className="row" style={{ gap: 10, width: "100%", alignItems: "center", minWidth: 0 }}>
      <span className="muted" style={{
        minWidth: 36, textAlign: "right", fontVariantNumeric: "tabular-nums",
        fontSize: 12, flexShrink: 0,
      }}>
        {known ? fmtDuration(prog * 1000) : "--:--"}
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <Slider
          value={known ? Math.min(prog, total) : 0}
          max={known ? total : 1}
          step={0.1}
          onChange={seek}
          disabled={!known}
          ariaLabel="progression"
        />
      </div>
      <span className="muted" style={{
        minWidth: 36, fontVariantNumeric: "tabular-nums",
        fontSize: 12, flexShrink: 0,
      }}>
        {known ? fmtDuration(total * 1000) : "--:--"}
      </span>
    </div>
  );
}
